<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeModal()">
  <div
    class="relative w-full max-w-2xl max-h-[90vh] bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700/50 flex flex-col overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div class="flex-none p-6 border-b border-slate-100 dark:border-slate-700 flex items-start justify-between gap-4">
      <div>
        <h3 class="text-lg font-black text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">history</span>
          {{ title }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium" *ngIf="subtitle || entityId">
          {{ subtitle || ('#' + entityId) }}
        </p>
      </div>
      <button type="button" (click)="closeModal()"
        class="w-9 h-9 rounded-xl border border-slate-100 dark:border-slate-700 text-slate-400 hover:text-rose-500 cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto p-6 custom-scrollbar relative min-h-[220px]">
      <div *ngIf="items().length === 0 && !isLoading()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block">inbox</span>
        ยังไม่มีประวัติการเปลี่ยนแปลง
      </div>

      <ol *ngIf="items().length > 0" class="relative border-l-2 border-amber-200 dark:border-amber-900/50 ml-3 space-y-5">
        <li *ngFor="let item of items(); trackBy: trackById" class="ml-6">
          <span
            class="absolute -left-[9px] mt-1.5 w-4 h-4 rounded-full border-2 border-white dark:border-slate-900"
            [ngClass]="{
              'bg-emerald-500': item.action === 'create',
              'bg-amber-500': item.action === 'update',
              'bg-rose-500': item.action === 'delete'
            }"></span>

          <button type="button" (click)="toggleExpand(item.id)"
            class="w-full text-left rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/60 p-4 hover:border-amber-300 transition-all cursor-pointer">
            <div class="flex flex-wrap items-center justify-between gap-2">
              <div class="flex items-center gap-2">
                <span class="px-2.5 py-1 rounded-full text-xs font-bold"
                  [ngClass]="{
                    'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': item.action === 'create',
                    'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': item.action === 'update',
                    'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400': item.action === 'delete'
                  }">
                  {{ actionLabel(item.action) }}
                </span>
                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ item.summaryTh || '—' }}</span>
              </div>
              <span class="text-xs text-slate-400 whitespace-nowrap">
                {{ item.createDate ? (item.createDate | date:'dd/MM/yyyy HH:mm') : '—' }}
              </span>
            </div>
            <div class="mt-1 text-xs text-slate-500">
              โดย {{ item.actorUsername || '—' }}
              <span *ngIf="item.actorUserId"> (#{{ item.actorUserId }})</span>
            </div>

            <div *ngIf="expandedId() === item.id" class="mt-3 pt-3 border-t border-slate-100 dark:border-slate-700"
              (click)="$event.stopPropagation()">
              <div *ngIf="item.changes.length === 0" class="text-xs text-slate-400">ไม่มีรายละเอียด field</div>
              <table *ngIf="item.changes.length > 0" class="w-full text-left text-xs">
                <thead class="text-slate-400 uppercase tracking-wider">
                  <tr>
                    <th class="pb-2 pr-2">รายการ</th>
                    <th class="pb-2 pr-2">ก่อน</th>
                    <th class="pb-2">หลัง</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100 dark:divide-slate-700">
                  <tr *ngFor="let c of item.changes">
                    <td class="py-2 pr-2 font-bold text-slate-600 dark:text-slate-300">{{ fieldLabel(c.field) }}</td>
                    <td class="py-2 pr-2 text-rose-600 dark:text-rose-400 break-all">{{ valueLabel(c.before) }}</td>
                    <td class="py-2 text-emerald-600 dark:text-emerald-400 break-all">{{ valueLabel(c.after) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </button>
        </li>
      </ol>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
